class AccessController {
  constructor() {
    this.providesAccess = false;
  }
  [Symbol.toPrimitive]() {
    return this.providesAccess;
  }
}

export { AccessController };
